import { render, staticRenderFns } from "./fission-campagin.vue?vue&type=template&id=54240fd8&scoped=true&"
import script from "./fission-campagin.vue?vue&type=script&lang=ts&"
export * from "./fission-campagin.vue?vue&type=script&lang=ts&"
import style0 from "./fission-campagin.vue?vue&type=style&index=0&id=54240fd8&prod&lang=scss&scoped=true&"
import style1 from "./fission-campagin.vue?vue&type=style&index=1&id=54240fd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54240fd8",
  null
  
)

export default component.exports